module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container is-fluid",
    attrs: {
      "id": "quest"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((300), function(n) {
    return _c(_vm.randomComp(), {
      ref: "inputs",
      refInFor: true,
      tag: "component"
    })
  }))]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "biteme"
    }
  }, [_c('button', {
    staticClass: "topcoat-button--large--cta",
    on: {
      "click": _vm.validateAllInputs
    }
  }, [_vm._v(_vm._s(_vm.bite()))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b405dc7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 118
// module chunks = 2